import React, { useContext, useState } from "react";
import { ProductContext } from "../../../stores/session";
import request from "../../../helpers/request";
import endpoints from "../../../helpers/endpoints";

export default function useExclude(data, getData, getWorkflowItems) {
    const { apiPrefix, isWorkflow, uuidColumn } = useContext(ProductContext)
    const [loading, setLoading] = useState(false)

    const excludeCustomer = async (reason, feedback) => {
        if (!data[uuidColumn]) return;
        setLoading(true);
        await request(true).post(endpoints[`${apiPrefix}_EXCLUDE_CUSTOMER`], {
            customer: data[uuidColumn],
            Occupier_Exclusion_Reason: reason,
            feedback: feedback,
        }).then(r => {
            setLoading(false)
            if (isWorkflow) {
                getWorkflowItems()
            } else {
                getData()
            }
        }).catch(e => {
            console.error(e);
        });
    }

    return { excludeCustomer, loading }
}